import { reactive, Div, H3, Button, Label, RadioInput, Input, Span, Checkbox } from 'alkali'
import Dialog from '../generic/DialogAlkali'
import { studyDetailsPane } from '../studies/StudyDetailsPane'
import { activeTab } from 'model/StudyCollection'

export class PromptToScreenDialog extends Dialog {
	get defaults() {
		return {
			head: {
				titleText: 'Screening Required',
			},
			id: 'screening-prompt-dialog',
			foot: {},
            size: '350px',
		}
	}
	ready(properties) {
		this.body.append(
			Div('.screening-body', [
				Div([`Screening has already been initiated and this study has not yet been marked "Included."
                Would you like to open this study for screening?`]),
			]),

		)
		this.footer.rightControls.append(
			Button('.btn', {
				textContent: 'Screen Study',
				onclick: () => {
                    activeTab.put('screening')
                    studyDetailsPane.showStudy(this.selectedStudy)
                    this.hide()
				},
			}),
			Button('.btn', {
				textContent: 'Cancel',
				onclick: () => {
                    this.hide()
				},
			})
		)

	}
}
